// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type SaveInsideMapsConfigMutationVariables = Types.Exact<{
  input: Types.SaveInsideMapsConfigInput;
}>;


export type SaveInsideMapsConfigMutation = { __typename?: 'Mutation', saveInsideMapsConfig: { __typename?: 'SaveInsideMapsConfigResult', productOffering: { __typename?: 'ProductOffering', id: string, readyPlanInsideMapsConfig?: { __typename?: 'ReadyPlanInsideMapsConfig', id: string, insideMapsConfig?: string | null | undefined } | null | undefined } } };


export const SaveInsideMapsConfigDocument = gql`
    mutation SaveInsideMapsConfig($input: SaveInsideMapsConfigInput!) {
  saveInsideMapsConfig(input: $input) {
    productOffering {
      id
      readyPlanInsideMapsConfig {
        id
        insideMapsConfig
      }
    }
  }
}
    `;
export type SaveInsideMapsConfigMutationFn = Apollo.MutationFunction<SaveInsideMapsConfigMutation, SaveInsideMapsConfigMutationVariables>;

/**
 * __useSaveInsideMapsConfigMutation__
 *
 * To run a mutation, you first call `useSaveInsideMapsConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveInsideMapsConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveInsideMapsConfigMutation, { data, loading, error }] = useSaveInsideMapsConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveInsideMapsConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveInsideMapsConfigMutation, SaveInsideMapsConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveInsideMapsConfigMutation, SaveInsideMapsConfigMutationVariables>(SaveInsideMapsConfigDocument, options);
      }
export type SaveInsideMapsConfigMutationHookResult = ReturnType<typeof useSaveInsideMapsConfigMutation>;
export type SaveInsideMapsConfigMutationResult = Apollo.MutationResult<SaveInsideMapsConfigMutation>;
export type SaveInsideMapsConfigMutationOptions = Apollo.BaseMutationOptions<SaveInsideMapsConfigMutation, SaveInsideMapsConfigMutationVariables>;